import {
  ADD_OOS_ITEM,
  ADD_TO_HEART_ID_LIST,
  RECEIVE_ALL_LISTS,
  RECEIVE_HEARTS,
  RECEIVE_HEARTS_IDS,
  RECEIVE_LIST_INFO,
  RECEIVE_SPECIFIC_ITEMID_LISTS,
  REMOVE_FROM_HEART_ID_LIST,
  TOGGLE_HEARTING_LOGIN_MODAL
} from 'constants/reduxActions';

export const initialState = {
  hearts: null,
  oosHearts: [],
  heartsStyleIds: [],
  heartLoginPrompt: { isOpen: false, id: null }
};

export default function hearts(state = initialState, action) {
  const { type, hearts, heartsStyleIds, nextPageToken, concat, styleId, itemId, open, id, list, lists, itemIdLists } = action;

  switch (type) {
    case RECEIVE_HEARTS:
      const newHearts = concat
        ? [...state.hearts, ...hearts]
        : hearts;
      return {
        ...state,
        hearts: newHearts,
        heartsStyleIds: newHearts.map(product => product.styleId),
        nextPageToken
      };
    case RECEIVE_HEARTS_IDS:
      return {
        ...state,
        heartsStyleIds: heartsStyleIds.map(product => product.itemId)
      };
    case REMOVE_FROM_HEART_ID_LIST:
      return {
        ...state,
        heartsStyleIds: state.heartsStyleIds.filter(item => item !== styleId)
      };
    case ADD_TO_HEART_ID_LIST:
      return {
        ...state,
        heartsStyleIds: [ styleId, ...state.heartsStyleIds ]
      };
    case ADD_OOS_ITEM:
      return {
        ...state,
        oosHearts: state.oosHearts.concat(itemId)
      };
    case TOGGLE_HEARTING_LOGIN_MODAL:
      return { ...state, heartLoginPrompt: { isOpen: open, id } };
    case RECEIVE_LIST_INFO:
      return { ...state, list };
    case RECEIVE_ALL_LISTS:
      return { ...state, ...lists };
    case RECEIVE_SPECIFIC_ITEMID_LISTS:
      return { ...state, itemIdLists: [...itemIdLists.ids] };
    default:
      return state;
  }
}
